import { createdATFilter } from 'modules/common/constants';

export const aiAssistantFilters = [createdATFilter];
